import React, { Component } from 'react';
import FormData from 'form-data';
import $ from 'jquery';
import axios from 'axios';
import passport from './../../../assets/images/passport.png';
import selfie from './../../../assets/images/selfie.png';
import PopUp from './popup.js';

export default class KYCUpload extends Component {

  render() {
    var kycprogress = window.kycprogress;

    $( document ).ready(function() {
      var accordion;
      if (kycprogress === "approved") {
        accordion = $('#kyc_document_accordion');
        accordion.html("Your KYC has been approved")
      } else if (kycprogress === "waiting") {
        accordion = $('#kyc_document_accordion');
        accordion.html("Your documents has been uploaded. To re-upload, please contact us at admin@daotoken.io")
      }
    });

    var show_kycUpgrade = function(){
      var show_accordion = $(".kycUpgrade");
      var panel = show_accordion.next();
      if (panel.css("maxHeight") !== "0px"){
          panel.css("maxHeight", "0px");
      } else {
          panel.css("maxHeight", panel.prop('scrollHeight') + "0px");
      }
    }

    var uploaded_passport = function() {
      var passport = $('#passport-file');
      $('#passport-name').html(passport.prop("files")[0].name);
    }

    var uploaded_photo = function() {
      var photo = $('#kyc-photo');
      $('#photo-name').html(photo.prop("files")[0].name);
    }

    var kycfiles = function() {

      const config = {
        headers: { 'content-type': 'multipart/form-data' }
      }

      axios.defaults.xsrfCookieName = 'csrftoken';
      axios.defaults.xsrfHeaderName = 'X-CSRFToken';

      var form = new FormData();
      var passport = $('#passport-file').prop("files")[0];
      var photo = $('#kyc-photo').prop("files")[0];

      console.log(passport);
      console.log(photo);

      if (passport && photo) {

        if (passport.size < 1048576 && photo.size < 1048576) {

          if (passport.type.includes("image/") && photo.type.includes("image/")) {
            form.append("passport", passport, passport.name);
            form.append("photo", photo, photo.name);


            axios.post('/api/kycfiles', form, config).then(function (response) {
              PopUp.prototype.show("Successfully uploaded, please wait for the approval");
              var accordion = $('#kyc_document_accordion');
              accordion.html("Your documents has been uploaded. To re-upload, please contact us at admin@daotoken.io")

            }).catch(function (error) {
              PopUp.prototype.show("failed");
            });
          } else {
            PopUp.prototype.show("You have to upload image files");
          }
        } else {
          PopUp.prototype.show("The files you uploaded more than 1 megabyte");
        }
      } else {
        PopUp.prototype.show("You have to submit both documents");
      }
    }

    return (
      <div class="row">
        <div class="col-lg-12 col-md-12 m-b-20" id="kyc_document_accordion">
          <button class="kycUpgrade accordion_green btn-block text-left active" onClick={show_kycUpgrade}>Upgrade your kyc level</button>
          <div class="accordion_panel">

            <div class="row">

            <p class="m-s-20" id="information">Upload image of your passport and selfie holding your passport to upgrade your kyc level</p>

              <div class="col-lg-6 col-md-6">
                <div class="m-t-20"></div>
                  <div>
                    <h5>Passport Photo:</h5>
                    <input onChange={uploaded_passport} class="visuallyhidden passport" type="file" name="passport" id="passport-file" />
                    <label for="passport-file" class="m-r-10 btn btn-blue w-md waves-effect waves-light"><strong>Choose a file</strong><span class="box__dragndrop"></span></label>
                    <p id="passport-name" class="m-t-20"></p>
                  </div>
              </div>

              <div class="m-b-20"></div>

              <div class="col-lg-6 col-md-6">
                <img src={passport} alt="passport example" class="kyc_example_img"/>
              </div>
            </div>


            <div class="row">

              <div class="col-lg-6 col-md-6">
                <div class="m-t-20"></div>
                  <h5>Personal Photo:</h5>
                  <div>
                    <input onChange={uploaded_photo} id="kyc-photo" class="visuallyhidden" type="file" name="photo"/>
                    <label for="kyc-photo" class="m-r-10 btn btn-blue w-md waves-effect waves-light"><strong>Choose a file</strong><span class="box__dragndrop"></span></label>
                    <p id="photo-name" class="m-t-20"></p>
                  </div>

                <div class="m-t-20"></div>
                <button id="upload-button" class="btn-green w-md waves-effect waves-light" onClick={kycfiles}>Upload</button>
              </div>

              <div class="m-b-20"></div>
              <div class="col-lg-6 col-md-6">
                <img src={selfie} alt="selfie with passport example" class="kyc_example_img"/>
              </div>
            </div>
            <p class="m-t-20 m-b-20">Upload both of photos and wait for approval. Pending will take 5-10 working days.</p>
            <p class="m-t-20 m-b-20">If you have any questions, please contact us through daotokenwallet@gmail.com</p>
        </div>
      </div>
    </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/functions/kyc_upload.js